import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./AuthModule/index";

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		AuthModule,
	},
	state: {
		cargando: true,
		fromStateSocial: localStorage.getItem('fs') || '/',
		// checkout: JSON.parse(localStorage.getItem('checkout')) || null,
		isSearching: false,
		menuNavOpened: false,
		menuUserOpened: false,
		transaccionData: JSON.parse(localStorage.getItem('transaccion_data')) || null,
	},
	getters: {
		isMenuNavOpened(state){
			return state.menuNavOpened
		},
		isMenuUserOpened(state){
			return state.menuUserOpened
		}
	},
	mutations: {
		cargando(state, isCargando) {
			state.cargando = isCargando;
		},
		setFromStateSocial(state, from) {
			state.fromStateSocial = from;
		},
		// setearCheckout(state, checkout){
		// 	state.checkout = checkout;
		// },
		// limpiarCheckout(state){
		// 	state.checkout = null;
		// },
		showIsSearching(state){
			state.isSearching = true;
		},
		hideIsSearching(state){
			state.isSearching = false;
		},
		setMenuNavOpened(state, menuOpened){
			state.menuNavOpened = menuOpened
		},
		setMenuUserOpened(state, menuOpened){
			state.menuUserOpened = menuOpened
		},
		setearTransaccionData(state, transaccionData){
			state.transaccionData = transaccionData;
		},
		limpiarTransaccionData(state){
			state.transaccionData = null;
		},
	},
	actions: {
		cargando(context, isCargando) {
			context.commit('cargando', isCargando);
		},
		showSuccess(context, msj) {
			return new Promise((resolve) => {
				this._vm.$toast.success(msj, {
					position: 'bottom-left',
					timeout: 6000,
					closeOnClick: true,
					pauseOnFocusLoss: false,
					pauseOnHover: true,
					draggable: false,
					draggablePercent: 0.6,
					showCloseButtonOnHover: true,
					hideProgressBar: true,
					closeButton: 'button',
					icon: true,
					rtl: false,
				});

				resolve();
			});
		},
		showError(context, err) {
			return new Promise((resolve) => {
				this._vm.$toast.error(err, {
					position: 'bottom-left',
					timeout: 6000,
					closeOnClick: true,
					pauseOnFocusLoss: false,
					pauseOnHover: true,
					draggable: false,
					draggablePercent: 0.6,
					showCloseButtonOnHover: true,
					hideProgressBar: true,
					closeButton: 'button',
					icon: true,
					rtl: false,
				});

				resolve();
			});
		},
		setFromStateSocial({ commit }, from) {
			commit('setFromStateSocial', from);
			localStorage.setItem('fs', from);
		},
		// setearCheckout(context, checkout){
		// 	return new Promise((resolve, reject) => {
		// 		localStorage.setItem('checkout', JSON.stringify(checkout))
		// 		context.commit('setearCheckout', checkout)
		// 	})
		// },
		// limpiarCheckout(context){
		// 	return new Promise((resolve, reject) => {
		// 		localStorage.removeItem('checkout')
		// 		context.commit('limpiarCheckout')
		// 		resolve()
		// 	})
		// },
		showIsSearching(context) {
			context.commit('showIsSearching');
			document.body.style.overflow = 'hidden';
		},
		hideIsSearching(context) {
			context.commit('hideIsSearching');
			document.body.style.overflow = 'auto';
		},
		setMenuNavOpened(context, menuOpened) {
			return new Promise((resolve, reject) => {
				context.commit('setMenuNavOpened', menuOpened)
			})
		},
		setMenuUserOpened(context, menuOpened) {
			return new Promise((resolve, reject) => {
				context.commit('setMenuUserOpened', menuOpened)
			})
		},
		setearTransaccionData(context, transaccionData){
			return new Promise((resolve, reject) => {
				localStorage.setItem('transaccion_data', JSON.stringify(transaccionData))
				context.commit('setearTransaccionData', transaccionData)
			})
		},
		limpiarTransaccionData(context){
			return new Promise((resolve, reject) => {
				localStorage.removeItem('transaccion_data')
				context.commit('limpiarTransaccionData')
				resolve()
			})
		},
	}
});